import { Flex, TableContainer, Table as ChakraTable, Thead, Tr, Th, Tbody, Td, Button, Input, InputGroup, InputRightElement, useToast, Select } from "@chakra-ui/react"
import { AdminCouponsEndpoints, fetcher } from "@olagg/api-hooks"
import { useEffect, useState } from "react";
import useRoles from "../../../features/Roles/hooks/useRoles";
import { OlaggModule, PermissionEnum } from "@olagg/db-types";
import { BsSearch } from "react-icons/bs";
import Pagination from "@olagg/ui-kit/Pagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { ROUTES } from "../../../consts/routes";
import Option from '../../../components/Option';

const Actions = ({ coupon }: { coupon: any }) => {
    const { missingPermission } = useRoles();
    const toast = useToast();
    const navigate = useNavigate();
    const removeCoupon = () => {
        if (window.confirm('¿Estás seguro que deseas eliminar este cupón?')) {
            let deleteFetch = AdminCouponsEndpoints.delete(coupon.id)
            if (coupon.type == 'PromotionalCoupon') deleteFetch = AdminCouponsEndpoints.deletePromotional(coupon.id);
            fetcher(deleteFetch)
                .then(() => {
                    window.location.reload();
                })
                .catch((error) => {
                    toast({
                        title: 'No se puede eliminar el cupon',
                        description: error.errors,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                        position: 'bottom-right'
                    })
                });
        }
    }

    const viewCoupon = () => {
        coupon?.type == 'PercentageCoupon' ? navigate(ROUTES.PRODUCTS.showCoupon.replace(':id', coupon.id)) : navigate(ROUTES.PRODUCTS.showPromoCoupon.replace(':id', coupon.id));
    };

    return (
        <Flex gap='10px'>
            {coupon.type != "TotalCoupon" && <Button isDisabled={missingPermission(OlaggModule.Product, PermissionEnum.EDIT)} bgColor={'#37A169'} p='0 10px' h='30px' fontSize={'14px'} onClick={() => viewCoupon()}>
                Ver
            </Button>}
            <Button isDisabled={missingPermission(OlaggModule.Product, PermissionEnum.DELETE)} bgColor={'#E53E3E'} p='0 10px' h='30px' fontSize={'14px'} onClick={() => removeCoupon()}>
                Eliminar
            </Button>
        </Flex>
    )
}

const STATUSES = [
    { label: 'Activo', value: 'active' },
    { label: 'Usado', value: 'used' },
    { label: 'Expirado', value: 'expired' },
]

const CouponsIndex = () => {
    const [coupons, setCoupons] = useState<any[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [count, setCount] = useState(0);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState({
        name: searchParams.get('name') || '',
        status: searchParams.get('status') || '',
        page: parseInt(searchParams.get('page') || '1'),
        limit: parseInt(searchParams.get('limit') || '10')
    });
    const getCoupons = ({ name, status, page, limit }: { name?: string, status?: string, page: number, limit: number }) => {
        fetcher(AdminCouponsEndpoints.all({ name, status, page, limit }))
            .then((data) => {
                setCoupons(data.coupons)
                setCount(data.meta.count);
            })
            .catch((error) => console.error(error));
    }

    const onFilter = ({
        name,
        value
    }: any) => {
        const parsedValue = (name === 'page' || name === 'limit') ? parseInt(value) : value;

        setFilter({ ...filter, [name]: parsedValue });

        if (value) searchParams.set(name, value);
        else searchParams.delete(name);
        setSearchParams(searchParams);
        window.location.hash = "cupones"
    }
    const { page, limit, name, status } = filter

    useEffect(() => {
        getCoupons({ name: name, status: status, page: page, limit: limit });
    }, [filter]);

    return (
        <Flex w='full' alignItems={"center"} justifyContent='center' px={'20px'} pb={'15px'} direction={"column"} gap='20px'>
            <Flex flexDirection={'row'} justify="space-between" pr={6} marginY="20px" w="100%">
                <Flex flex="1" alignItems={"center"} gap="4">
                    <InputGroup w="25%">
                        <Input
                            color={"white"}
                            placeholder="Email del user"
                            name="name"
                            onChange={(e) => onFilter({ name: 'name', value: e.target.value })}
                            value={filter?.name}
                        />
                        <InputRightElement children={<BsSearch color="white" />} />
                    </InputGroup>
                    <InputGroup w="25%">
                        <Select
                            mt='5' mb='5'
                            style={{ color: 'white' }}
                            maxW='200px'
                            onChange={(e) => onFilter({
                                name: 'status',
                                value: e.target.value
                            } as EventTarget & HTMLInputElement)}
                            value={filter?.status}
                        >
                            <Option value=''>Todos los estados</Option>
                            {STATUSES.map(status => (
                                <Option key={status.value} value={status.value}>{status.label}</Option>
                            ))}
                        </Select>
                    </InputGroup>
                </Flex>
                <Button
                    my={4}
                    variant="outlinedGradient"
                    leftIcon={<FaPlus />}
                    onClick={() => navigate(ROUTES.PRODUCTS.createCoupon)}
                    mb='3'
                    mr='4'
                >
                    Cupón de descuento
                </Button>
                <Button
                    my={4}
                    variant="outlinedGradient"
                    leftIcon={<FaPlus />}
                    onClick={() => navigate(ROUTES.PRODUCTS.createPromoCoupon)}
                    mb='3'
                >
                    Cupón Promo de descuento
                </Button>
            </Flex>
            <TableContainer overflowX={'scroll'} overflowY={'scroll'} w="100%" maxH="60vh">
                <ChakraTable
                    variant="striped"
                    size="sm"
                    colorScheme="olaggPurple"
                    fontSize="18px"
                    position='relative'
                    whiteSpace={'normal'}
                >
                    <Thead>
                        <Tr position='sticky' bg='gray.800' top='0' zIndex='100'>
                            <Th py={'20px'} color="white">Tipo</Th>
                            <Th py={'20px'} color="white">Producto</Th>
                            <Th py={'20px'} color="white">Asignado a</Th>
                            <Th py={'20px'} color="white">Codigo</Th>
                            <Th py={'20px'} color="white">Limite</Th>
                            <Th py={'20px'} color="white">Porcentaje (%)</Th>
                            <Th py={'20px'} color="white">Token</Th>
                            <Th py={'20px'} color="white">Fecha de vencimiento</Th>
                            <Th py={'20px'} color="white">Estado</Th>
                            <Th py={'20px'} color="white">Acciones</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {coupons.map((coupon, index) => (
                            <Tr key={index} color="white">
                                <Td py={'20px'}>{coupon.type == "TotalCoupon" ? "Total" : coupon.type == "PromotionalCoupon" ? "Promo" : "Porcentaje"}</Td>
                                <Td py={'20px'}>{coupon.product?.name}</Td>
                                <Td py={'20px'}>ID: {coupon.user?.id} - {coupon.user?.name} - {coupon.user?.email}</Td>
                                <Td py={'20px'}>{coupon.code}</Td>
                                <Td py={'20px'}>{coupon.limit}</Td>
                                <Td py={'20px'}>{coupon.percentage}</Td>
                                <Td py={'20px'}>{coupon.token}</Td>
                                <Td py={'20px'}>{coupon.dueDate ? new Date(coupon.dueDate).toLocaleString() + ' UTC' : 'Sin vencimiento'}</Td>
                                <Td py={'20px'}>
                                    {coupon.status === 'active' && <span style={{ color: '#38A169', fontWeight: 'bold' }}>Activo</span>}
                                    {coupon.status === 'used' && <span style={{ color: '#3182CE', fontWeight: 'bold' }}>Usado</span>}
                                    {coupon.status === 'expired' && <span style={{ color: '#E53E3E', fontWeight: 'bold' }}>Expirado</span>}
                                </Td>
                                <Td py={'20px'}>
                                    <Actions coupon={coupon} />
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </ChakraTable>
            </TableContainer>
            <Flex flexDirection={'row'} justify="space-between" pr={6}>
                <Pagination
                    params={{ limit, page, count }}
                    onClick={page =>
                        onFilter({
                            name: 'page',
                            value: String(page + 1)
                        } as EventTarget & HTMLInputElement)
                    }
                    onLimitChange={val =>
                        onFilter({
                            name: 'limit',
                            value: val
                        } as EventTarget & HTMLInputElement)
                    }
                    hideLimitInput
                />
            </Flex>
        </Flex>
    )
}

export default CouponsIndex;